import { useModal } from 'vue-final-modal'

import SuggestImprovements from '~/components/modal-windows/SuggestImprovements.vue'
import Page from '~/enums/page'
import { useAuthStore } from '~/store/auth'
import { useProductsStore } from '~/store/products'
import { useUserStore } from '~/store/user'

export function useAccount () {
  const { $toast } = useNuxtApp()
  const router = useRouter()
  const authStore = useAuthStore()
  const productsStore = useProductsStore()
  const userStore = useUserStore()

  async function openFeedbackModalWindow (textPrefix: string): Promise<void> {
    await useModal({ component: SuggestImprovements, attrs: { textPrefix } }).open()
  }

  async function signOut (needToShowToast = true, needToRedirectToMainPage = true) {
    useCookie('token').value = null
    useCookie('userId').value = null

    authStore.$reset()
    productsStore.$reset()
    userStore.$reset()

    if (needToShowToast) {
      $toast.success('Выход выполнен.')
    }

    if (needToRedirectToMainPage) {
      await router.push(Page.Main)
    }
  }

  return { openFeedbackModalWindow, signOut }
}
